"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MZFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_165)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_165`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H36V24H0V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 16.7018H36V24H0V16.7018Z",
					fill: "#F4D900"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H36V7.29824H0V0Z",
					fill: "#006D66"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 8.35089H36V15.6491H0V8.35089Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M17.9649 11.9771L0 23.9534V-0.00012207L17.9649 11.9771Z",
					fill: "#CB0F31"
				}),
				/* @__PURE__ */ n("path", {
					d: "M5.85804 7.7052L6.91818 10.9682H10.3493L7.57362 12.985L8.63376 16.2481L5.85804 14.2314L3.08225 16.2481L4.1426 12.985L1.36688 10.9682H4.7979L5.85804 7.7052Z",
					fill: "#F4D900"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_165`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MZFlag };
